export enum AuthMethod {
  Email = 'email',
  Wallet = 'wallet',
  Telegram = 'telegram',
}

export const EMAIL_DOMAIN_BANNED_ERROR_CODE = 'error_email_invalid'
export const EMAIL_EXISTED_ERROR_CODE = 'error_data_exists'
export const EMAIL_INVALID_ERROR_CODE = 'error_invalid_params'
